<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 批量注册设备
        </span>

        <div class="tableWrapper">
          <el-form ref="addEquipment" :model="addEquipment" :rules="rules">
            <el-form-item label="区域选择" style="width: 200px;">
              <el-input
                placeholder="请选择区域"
                v-model="seefrom.curAreaName"
                @focus="changeAreaMode(1)"
              ></el-input>
            </el-form-item>
            <el-form-item label="导入文件">
              <input
                id="test"
                type="file"
                ref="clearFile"
                @change="getFile($event)"
                multiple="multiplt"
                class="add-file-right-input"
                accept=".xlsx"
              />
            </el-form-item>
            <el-form-item label="">
            导出excel模板：<downloadBtn url="extra/regDevice/export/exportList" :params="seefrom" method="post" :needUserId="true"></downloadBtn>
            </el-form-item>
            <el-form-item label="">

            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayForm = false"
            >取 消</el-button
            >
            <el-button class="confirmButton" type="primary" @click="submitForm"
            >确 定</el-button
            >
          </div>
        </div>
        <!-- 区域树 -->
        <mountPoint
          :hasChildNodes="areaTreeMode"
          :dialogVisible="areaTreeVisible"
          @regionTreeClose="areaTreeVisible = false"
          @regionTreeData="selRegionData"
        ></mountPoint>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        rules: {

        },
        //区域树是否显示
        areaTreeVisible: false,
        areaTreeMode: true,
        //选择区域树模式 查询 ？ 新增 ？
        areaMode: 1,
        seeDisplayForm: false,
        displayForm: false,

        tabName: "jsgl",
        form_jsgl: {},
        title: "",
        other: {},
        items: [],
        seefrom: {
          regionId:1,
          curAreaName:''
        },
        addEquipment: {
          system_id: "",
          device_type: "",
          factory: "",
          model: "",
          pumpType: null,
        },
        seeDisplayForm: false,
        displayForm: false,
        SystemId: [],
        factoryList: [],
        options: [],
        deviceModeList: [],
        //上传文件
        addArr: [],
        tableData: [],
        //设备额外信息
        equipment: {
          protocolTypeName: "",
        },
        //设备种类（网关）
        deviceKind: "",
      };
    },
    computed: {
      self() {
        return this;
      },

      dt() {
        return dt.map(({ label }) => label);
      },
    },
    components: {
      normalNav: () => import("public/normalNav"),
      searchForm: () => import("public/searchForm"),
      easyTable: () => import("public/easyTable"),
      mountPoint: () => import("public/mountPoint"),
      downloadBtn:() => import('public/download'),
    },
    methods: {
      //区域树选择完回调
      selRegionData(a, ...b) {
        let mode = this.areaMode;
        if (mode === 1) {
          this.seefrom.regionId = a.id;
          this.seefrom.curAreaName = a.name;
        }
      },
      //选择区域模式变化
      changeAreaMode(mode) {
        this.areaTreeVisible = true;
        if (mode === 1) this.areaTreeMode = true;
        if (mode === 2) this.areaTreeMode = false;
        this.areaMode = mode;
      },
      //上传文件
      getFile(event) {
        var file = event.target.files;
        this.addArr = [];
        // for (var i = 0; i < file.length; i++) {
        //    上传类型判断
        var imgName = file[file.length - 1].name;
        var idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          var ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          if (ext === "xlsx") {
            this.addArr = file[file.length - 1];
            //console.log(this.addArr, "addArr");
          } else {
            this.$message.error("文件类型错误！");
          }
        }
        // }
      },

      reset() {
        this.seefrom = {
          system_id: "",
          device_ype: "",
          factory: "",
          model: "",
          startTime: "",
          endTime: "",
        };
      },
      //确认
      submitForm() {
        //console.log(this.addArr);
        if (this.addArr.length === 0) {
          this.$notify({
            message: "请选择文件！",
            type: "warning",
          });
          return;
        } else {
          var formData = new FormData();
          formData.append("file", this.addArr);
          formData.append("model", "");
          formData.append("device_type", "");
          formData.append("system_id", "");
          formData.append("factory", "");

          //this.$refs["addEquipment"].validate((valid) => {
          //  if (valid) {
              this.displayForm = false;
              //console.log(this.addArr, "submit");
              this.$axiospost("extra/regDevice/add", formData).then((res) => {
                if (res.data.status == "10000") {
                  //console.log('导入成功!')
                  // 如果deviceList中有数据，那么就是导入失败的数据
                  this.$message.success("导入成功！");
                }
              });
          //  }
          //});
        }
      },
    },
    mounted() {

    },
  };
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/registerDevice.vue